import {
    DEALERGETFEEREPORTLIST_SUCCESS,
    DEALERGETFEEREPORTLIST_FAILED,
    RESET_DEALERGETFEEREPORTLIST,
    LOADING_DEALERGETFEEREPORTLIST,
    NETWORK_ERROR_DEALERGETFEEREPORTLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERGETFEEREPORTLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERGETFEEREPORTLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERGETFEEREPORTLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERGETFEEREPORTLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERGETFEEREPORTLIST:
            return (state = initialState);
        default:
            return state;
    }
};